
<script>
    import SeedItem from './SeedsItem.svelte'
    export let exploreMode;
    export let seedSubset;
</script>

{#if exploreMode === 'seed'}
    {#each seedSubset as seed}
        <SeedItem 
            plantName={seed.plantName} 
            seedName={seed.seedName} 
            description={seed.seedDescription} 
            id={seed.id} 
            on:buy-now
            />
    {/each}
{/if}